<template lang="html">
  <div class="transfer form" v-loading="loading">
    <div class="cell title">
      <div class="check"></div>
      <div class="pkg-title">{{message.Fl112}}</div>
      <div class="sender">{{message.Fl113}}</div>
      <div class="receivers">{{message.Fl114}}</div>
      <div class="size">{{message.Fl115}}</div>
      <div class="num">{{message.Fl116}}</div>
      <div class="time">{{message.Fl117}}</div>
      <div class="delete"></div>
    </div>
    <div class="cell" :class="pkg.class" v-for="(pkg, index) in pkgs" :key="pkg.id">
      <div class="check"></div>
      <div class="pkg-title" :title="pkg.title" @click="moreInfo(pkg.id, pkg.title)">
        {{ pkg.title }}
      </div>
      <div class="sender" :title="pkg.sender">
        {{ pkg.sender }}
      </div>
      <div class="receivers" :title="pkg.receivers">
        {{ pkg.receivers }}
      </div>
      <div class="size">
        {{ pkg.size }}
      </div>
      <div class="num">
        {{ pkg.num }}
      </div>
      <div class="time">
        {{ pkg.time }}
      </div>
      <i v-if="pkg.class!=='delete'" class="delete material-icons" @click="openDelete(pkg.id, pkg.title, index)">
        delete
      </i>
    </div>
    <div class="page" v-show="total > 12">
      <el-pagination
        small
        layout="prev, pager, next"
        :page-size="12"
        :total="total"
        :current-page.sync="num"
        @current-change="pkgsList()"
        >
      </el-pagination>
    </div>
    <el-dialog width="820px" class="dialog" :title="info.title" :visible.sync="dialog" append-to-body>
      <div class="info">
        <div class="cell notes">
          <div class="name">{{message.Sl118}}</div>
          <div class="info">{{ info.notes }}</div>
        </div>
        <div class="cell">
          <div class="name">{{message.Sl150}}</div>
          <div class="info">{{ info.expires.time }}</div>
        </div>
        <div class="cell" v-if="info.isDelete.is">
          <div class="name">{{message.Sl151}}</div>
          <div class="info">{{ info.isDelete.name }}</div>
        </div>
      </div>
      <div class="fileList" style="padding-top:6px;height:272px;margin-bottom:15px;margin-top:15px;border-top:1px solid #ccc" v-loading="filesLoading">
        <comp-files
          v-for = "(file, index) in files"
          :key="index"
          :id="file.id"
          :name="file.name"
          :size="file.size"
          :percent="file.percent"
          :checkedList="[]"
        >
        </comp-files>
      </div>
      <div class="page" v-show="info.total > 8">
        <el-pagination
          small
          layout="prev, pager, next"
          :page-size="8"
          :total="info.total"
          :current-page.sync="info.num"
          @current-change="pageList()"
          >
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CompFiles from '@/components/other/workspace/components/files.vue'
export default {
  components: {
    CompFiles
  },
  data () {
    return {
      message: {
        Fl112: this.$lang.ui.form.l112,
        Fl113: this.$lang.ui.form.l113,
        Fl114: this.$lang.ui.form.l114,
        Fl115: this.$lang.ui.form.l115,
        Fl116: this.$lang.ui.form.l116,
        Fl117: this.$lang.ui.form.l117,
        Sl118: this.$lang.ui.system.l118,
        Sl150: this.$lang.ui.system.l150,
        Sl151: this.$lang.ui.system.l151
      },
      loading: false,
      num: 1,
      total: 12,
      pkgs: [],
      dialog: false,
      filesLoading: false,
      info: {
        id: '',
        title: '',
        num: 1,
        total: 1,
        isDelete: {},
        expires: {},
        notes: ''
      },
      files: []
    }
  },
  props: {
    id: String,
  },
  mounted () {
    this.num = 1
    this.getPkgs(1)
  },
  methods: {
    pkgsList () {
      this.getPkgs(this.num)
    },
    pageList () {
      this.fileList(this.info.id, this.info.title)
    },
    moreInfo (id) {
      this.packageInfo(id)
      this.fileList(id)
    },
    packageInfo (id) {
      this.$http.get('/cydex/api/v1/packages/' + id)
        .then(response => {
          var data = response.data
          if (data.is_deleted) {
            if (data.deletion.deleted_by === 'expires') {
              var name = this.$lang.ui.notice.l115
              var type = 'expires'
            }
            if (data.deletion.deleted_by === 'expires_after_download') {
              name = this.$lang.ui.notice.l115
              type = 'after'
            }
            if (
              data.deletion.deleted_by !== 'expires' &&
            data.deletion.deleted_by !== 'expires_after_download'
            ) {
              name = data.deletion.deleted_by_name
              type = 'user'
            }
            var isDelete = {
              is: true,
              name: name,
              type: type,
              time: this._global.timeSwitch(data.deletion.real_delete_expires + data.deletion.deleted_at)
            }
          } else {
            isDelete = {
              is: false,
              name: '-',
              type: '-',
              time: '-'
            }
          }
          if (data.expiration.expires !== 0) {
            var expires = {
              time: this._global.timeSwitch(data.expiration.expire_at)
            }
          } else {
            expires = {
              time: '-'
            }
          }
          this.info.title = data.title
          this.info.notes = data.notes
          this.info.expires = expires
          this.info.isDelete = isDelete
        })
    },
    fileList (id) {
      this.dialog = true
      this.info.id = id
      this.files = []
      this.filesLoading = true
      this.$http.get('/cydex/api/v1/packages/' + id + '/files', { params: {
        'with_sender': 1,
        'page_num': this.info.num,
        'page_size': 8
      } })
        .then(response => {
          this.files = []
          this.info.total = response.data.total_num
          for (var i = 0; i < response.data.files.length; i++) {
            var percent = parseInt(response.data.files[i].sender.finished_size / response.data.files[i].size * 100)
            this.files.push({
              id: response.data.files[i].id,
              name: response.data.files[i].name,
              size: this._global.trafficSwitch(response.data.files[i].size),
              percent: percent
            })
          }
          this.filesLoading = false
        })
    },
    getPkgs (num) {
      this.loading = true
      this.pkgs = []
      this.$http.get('/cydex/api/v1/packages', { params: {
        'project_id': this.id,
        'page_size': 12,
        't': 's',
        'u': 'all',
        'page_num': num,
        'with_sender': 1,
        'with_receivers': 1
      } })
        .then(response => {
          this.loading = false
          this.pkgs = []
          this.total = response.data.total_num
          var data = response.data.packages
          for (var i = 0; i < data.length; i++) {
            if (data[i].receivers !== null) {
              for (var x = 0; x < data[i].receivers.length; x++) {
                if (x === 0) {
                  var receivers = data[i].receivers[x].user.name
                } else {
                  receivers = receivers + ',' + data[i].receivers[x].user.name
                }
              }
            } else {
              receivers = '-'
            }
            if (data[i].is_deleted) {
              var style = 'delete'
            } else {
              style = ''
            }
            this.pkgs.push({
              id: data[i].id,
              title: data[i].title,
              sender: data[i].sender.user.name,
              receivers: receivers,
              class: style,
              size: this._global.trafficSwitch(data[i].size),
              num: data[i].files_num_file || data[i].files_num,
              time: this._global.timeSwitch(data[i].create_at)
            })
          }
        })
    },
    openDelete (id, name, index) {
      this.$confirm(this.$lang.ui.prompt.l137.l0 + name + this.$lang.ui.prompt.l137.l1, this.$lang.ui.system.l133, {
        confirmButtonText: this.$lang.ui.form.l100,
        cancelButtonText: this.$lang.ui.form.l101,
        type: 'warning'
      })
        .then(() => {
          this.deletePkg(id, index)
        })
        .catch(() => {
        })
    },
    deletePkg (id, index) {
      this.$http.delete('/cydex/api/v1/packages/' + id)
        .then(response => {
          this.pkgs[index].class = 'delete'
          this.$message({
            message: this.$lang.ui.prompt.l113,
            type: 'success',
            duration: 2000
          })
        })
    }
  }
}
</script>

<style lang="css">
.transfer.form {
  position: relative;
  background-color: #fff;
  padding: 20px;
  padding-bottom: 40px;
  width: 810px;
  margin: 15px auto;
  border-radius: 4px;
  height: 528px;
  -webkit-box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.149019607843137);
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.149019607843137);
}
.transfer .page {
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 6px;
  text-align: center;
}
.transfer .cell {
  height: 36px;
  width: 100%;
}
.transfer .cell.title {
  display: block;
  font-weight: 600;
  border-bottom: 1px solid #cdcdcd;
  line-height: 30px;
  width: 100%;
}
.transfer .name {
  right: 200px;
}
.transfer .cell .check,
.transfer .cell .pkg-title,
.transfer .cell .sender,
.transfer .cell .receivers,
.transfer .cell .size,
.transfer .cell .num,
.transfer .cell .time,
.transfer .cell .delete
 {
  display: block;
  text-align: left;
  padding-right: 15px;
  font-size: 14px;
  float: left;
  height: 36px;
  line-height: 36px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.transfer .cell .check {
  width: 35px;
  padding-right: 0;
  text-align: center;
}
.transfer .cell .pkg-title {
  width: calc(100% - 630px)
}
.transfer .cell .sender {
  width: 110px;
}
.transfer .cell .receivers {
  width: 170px;
}
.transfer .cell .size {
  width: 85px;
}
.transfer .cell .num {
  width: 70px;
}
.transfer .cell .time {
  width: 126px;
}
.transfer .cell .delete {
  position: absolute;
  right: 20px;
  display: none;
  text-align: center;
  cursor: pointer;
  padding-right: 0;
  width: 35px;
  font-size: 24px;
}
.transfer .cell .delete:hover {
  color: #d43f3a;
}
.transfer .cell:hover {
  background-color: #e6e6e6;
  border-radius: 4px;
}
.transfer .cell:hover .delete {
  display: inline-block;
}
.transfer .el-loading-mask {
  background-color: transparent !important;
}
.transfer .dialog .el-dialog--small {
  width: 680px !important;
}
.transfer .cell:hover .pkg-title {
  cursor: pointer;
  text-decoration: underline;
}
.transfer .cell.delete {
  opacity: 0.5;
}
.transfer .dialog .cell {
  text-align: left;
  line-height: 36px;
  padding: 0 20px;
}
.transfer .dialog .cell .name {
  display: inline-block;
  width: auto;
  font-weight: 600;
}
.transfer .dialog .cell .info {
  display: inline-block;
  width: auto;
}
</style>
